var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      Object.keys(_vm.$i18n).length > 0
        ? _c(_vm.layout, {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.layout,
                expression: "layout"
              }
            ],
            tag: "component"
          })
        : _vm._e(),
      _vm._v(" "),
      _c("theme"),
      _vm._v(" "),
      _c("loader")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48ab070e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ab070e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/root.vue
// module id = 1264
// module chunks = 28